$(document).ready(function () {
  $('.js-slice-text').each(function(i) {
    sliceText($(this), 120)
  });

  $('.js-big-slice-text').each(function(i) {
    sliceText($(this), 155)
  });

  function sliceText(context, length) {
    if (context.text().length >= length) {
      context.text( context.text().slice(0, length) + '...' );
    }
  }
});